import moment from 'moment';

export const sortByNumber = (a, b) => a - b;

export const sortByName = (data, nameKey) => {
    return [...data].sort((a, b) => (a[nameKey] < b[nameKey]) ? -1 : (a[nameKey] > b[nameKey]) ? 1 : 0);
};

export const sortByDate = (data, dateKey, dateFormat, descending = false) => {
    const orderedAscending = [...data].sort((a, b) => (moment(a[dateKey], dateFormat) - moment(b[dateKey], dateFormat)));

    return descending ? orderedAscending.reverse() : orderedAscending;
};

export const sortByLastName = (name1, name2) => {
    if (name1 === null || name1 === undefined) { return -1; }
    if (name2 === null || name2 === undefined) { return 1; }
    if ((name1 === null || name1 === undefined) && (name2 === null || name2 === undefined)) {
        return 0;
    }
    name1 = name1.original.player.lastName;
    name2 = name2.original.player.lastName;
    return name1.localeCompare(name2);
};

